import type { CustomContainerComponentProps } from "virtua";

/**
 * The virtualizer's content element for a list whose rows are wider than the viewport. `virtua` paints
 * its content element with `contain: content`, so rows overflowing it are clipped and can never make
 * the viewport scroll horizontally; giving the element itself the rows' minimum width lets it be the
 * thing that overflows instead. The width arrives as a CSS variable set on the viewport, because
 * `virtua` owns this element's props.
 */
export const MinWidthContent = ({ style, children, ref }: CustomContainerComponentProps) => (
  <div
    ref={ref}
    data-slot="paginated-list-content"
    style={{ ...style, minWidth: "var(--paginated-list-content-min-width)" }}
  >
    {children}
  </div>
);
